import config from '@/config';
import { requests } from '.';
const customFieldsUrl = config.CUSTOM_FIELDS_SERVICE_URL;
export const CustomFieldsServices = {
    getContactCustomFields: (locationId) => requests(customFieldsUrl).get(`/${locationId}/customFields/search?includeStandards=false`),
};
